<template>
  <div class="foots">
    <div class="foots_border">
      <div class="foot" id="anchor5">
        <div class="foot_banner">
          <div class="foot_banner_left">
            <img src="../../assets/img/hei@2x.png" alt="" />
          </div>
          <div class="foot_banner_centre">
            <div>
              <i>联系方式</i>
            </div>
            <div>
              <img src="../../assets/img/zuoji@2x.png" alt="" />
              <p>0571-88955078</p>
            </div>
            <div>
              <img src="../../assets/img/phone.png" alt="" />
              <p>商务合作：18106580695</p>
            </div>
            <div>
              <img src="../../assets/img/dizhi@2x.png" alt="" />
              <p>浙江省杭州市余杭区五常大道181号华立云立方3幢502室</p>
            </div>
            <div>
              <span
                >版权所有©2020杭州禾平数据 备案/许可证号：<a
                  href="https://beian.miit.gov.cn/#/Integrated/index"
                  target="_blank"
                  >浙ICP备19000799号</a
                ></span
              >
            </div>
          </div>
          <div class="foot_banner_right">
            <div class="right_top">关注我们</div>
            <div class="banner_right_f">
              <div>
                <img src="../../assets/img/gongzhonghao@2x.png" alt="" />
                <p>公众号</p>
              </div>
              <div>
                <img src="../../assets/img/weixinhao.png" class="weixin_box" alt="" />
                <p class="weixin_box">微信号</p>
              </div>
              <!-- <div>
                <img src="../../assets/img/weixin@2x.png" alt="" />
                <p>微信号</p>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
<style>
/* 页脚 */
.foots {
  width: 100%;
  margin: 0 auto;
  height: 251px;
  background-image: url("../../assets/img/bottom@2x.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.footlist {
  width: 1200px;
  margin: 0 auto;
  height: 341px;
  display: flex;
  justify-content: space-between;
}
.footlist_box {
  margin-top: 40px;
  width: 168px;
}
.footlist_box p {
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
}
.footlist_box a {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;

  margin-top: 16px;
}
.footlist_box a:hover {
  color: #1958c4;
}
.foot {
  width: 100%;
  margin: 0 auto;
}
.foot_banner {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding-top: 32px;
  color: #333333;
}
.foot_banner_left img {
  width: 279px;
  height: 66px;
}
.foot_banner_centre p {
  font-size: 16px;
  font-weight: 400;
  margin-left: 5px;
  line-height: 1.1;
}
.foot_banner_centre i {
  font-size: 22px;
  font-weight: 600;
}
.foot_banner_centre div {
  display: flex;
  flex-wrap: nowrap;
  margin-bottom: 20px;
}
.foot_banner_centre span {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  margin-top: 13px;
}
.foot_banner_centre span a {
  color: #666666;
}
.foot_banner_centre img {
  width: 16px;
  height: 16px;
}
.banner_right_h {
  font-size: 22px;
  font-weight: 600;
}
.foot_banner_right div {
  margin-bottom: 10px;
}
.right_top{
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  margin-bottom: 20px!important;
}
.banner_right_f {
  display: flex;
}
.banner_right_h {
  margin-left: 32px;
}
.banner_right_f img {
  width: 120px;
  height: 120px;
  margin-bottom: 5px;
  /*margin-left: 32px;*/
}
.weixin_box{
  margin-left: 32px;
}
.banner_right_f div {
  text-align: center;
}
.banner_right_f p {
  /*margin-left: 32px;*/
  color: #666666;
}
.footlist_box a {
  display: block;
}
</style>
